import React from "react";

import dayjs from "dayjs";

import {CircularProgress, Stack} from "@mui/joy";

// components
import CommonInfoTab from "../Common/CommonInfoTab";
import BaseApi from "../../utils/BaseApi";

// icons
import InfoIcon from "@mui/icons-material/Info";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ContactPageIcon from '@mui/icons-material/ContactPage';


class LetterDetailInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            letter: null,
            extraData: null,
        };
    }

    async componentDidMount(){
        await this.retrieveLetter()
        await this.retrieveExtraData();
    }

    async retrieveExtraData(){
        let extraData = {};
        const api = new BaseApi();
        let url;
        let response;
        if (!this.props.letter.lead){
            url = `contact/`;
            response = await api.get(
                url,
                {
                    entity: 'Account',
                    entity_id: this.props.letter.contact?.account.id,
                    page_size: 10000,
                }
            );
            extraData.contacts = response.data.results.map((each) => (
                {'value': each.id, 'label': `${each.first_name} ${each.last_name} - ${each.role}`}
            ))
        }
        url = `account/customers/`;
        response = await api.get(
            url,
            {
                page_size: 10000,
            }
        );
        extraData.accounts = response.data.results.map((each) => (
            {'value': each.id, 'label': each.nameshort}
        ))
        url = `subscriber/`;
        response = await api.get(
            url,
            {
                active: true,
                can_sign_letters: true,
                page_size: 10000,
            }
        );
        extraData.signature = response.data.results.map((each) => (
            {'value': each.id, 'label': `${each.user.first_name} ${each.user.last_name}`}
        ))
        this.setState(
            {
                extraData: extraData,
            }
        )
    }

    async retrieveLetter() {
        this.setState(
            {
                letter: null,
            }
        )
        const api = new BaseApi();
        let url;
        let letter;
        let response
        url = `letter/${this.props.letter.id}`;
        response = await api.get(
            url,
            {}
        );
        letter = response.data;
        this.setState(
            {
                letter: letter,
            }
        )
    }

    render() {
        if (!this.state.letter || !this.state.extraData) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
            >
                <CommonInfoTab
                    callBack={this.retrieveLetter.bind(this)}
                    groups={
                        [
                            {
                                title: 'Общая информация',
                                icon: <InfoIcon />,
                                fields: [
                                    {
                                        title: 'Номер',
                                        value: this.state.letter.number,
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        edit: {
                                            permission: true,
                                            fields: ['number',],
                                            baseUrl: 'letter',
                                            obj: this.state.letter
                                        }
                                    },
                                    {
                                        title: 'Тема',
                                        value: this.state.letter.title,
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        edit: {
                                            permission: true,
                                            fields: ['title',],
                                            baseUrl: 'letter',
                                            obj: this.state.letter
                                        }
                                    },
                                    {
                                        title: 'В ответ на номер',
                                        value: this.state.letter.incoming_number,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        edit: {
                                            permission: true,
                                            fields: ['incoming_number',],
                                            baseUrl: 'letter',
                                            obj: this.state.letter
                                        }
                                    },
                                    {
                                        title: 'В ответ на дата',
                                        value: this.state.letter.incoming_date?dayjs(this.state.letter.incoming_date).format('DD MMM YYYY'):this.state.letter.incoming_date,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        edit: {
                                            permission: true,
                                            fields: ['incoming_date',],
                                            baseUrl: 'letter',
                                            obj: this.state.letter
                                        }
                                    },
                                ]
                            },
                            {
                                title: 'Текст',
                                icon: <TextSnippetIcon/>,
                                fields: [
                                    {
                                        title: 'Блок о компании',
                                        value: this.state.letter.about_company,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        edit: {
                                            permission: true,
                                            fields: ['about_company',],
                                            baseUrl: 'letter',
                                            obj: this.state.letter,
                                        }
                                    },
                                    {
                                        title: 'Тексты в блок Сообщаем',
                                        value: this.state.letter.letter_wordings,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: true,
                                            fields: [],
                                            m2mFields: ['letter_wordings', ],
                                            baseUrl: 'letter',
                                            obj: {
                                                id: this.state.letter.id,
                                                letter_wordings: this.state.letter.letter_wordings.map((item) => (item.id))
                                            }
                                        }
                                    },
                                    {
                                        title: 'Список преимуществ от совместной работы',
                                        value: this.state.letter.businesses,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: true,
                                            fields: [],
                                            m2mFields: ['businesses', ],
                                            baseUrl: 'letter',
                                            obj: {
                                                id: this.state.letter.id,
                                                businesses: this.state.letter.businesses.map((item) => (item.id))
                                            }
                                        }
                                    },
                                    {
                                        title: 'Список преимуществ задач',
                                        value: this.state.letter.tasks,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: true,
                                            fields: [],
                                            m2mFields: ['tasks', ],
                                            baseUrl: 'letter',
                                            obj: {
                                                id: this.state.letter.id,
                                                businesses: this.state.letter.tasks.map((item) => (item.id))
                                            }
                                        }
                                    },
                                    {
                                        title: 'Компании',
                                        value: this.state.letter.accounts,
                                        fieldFromArray: 'nameshort',
                                        edit: {
                                            permission: true,
                                            fields: [],
                                            m2mFields: ['accounts', ],
                                            baseUrl: 'letter',
                                            obj: {
                                                id: this.state.letter.id,
                                                accounts: this.state.letter.accounts.map((item) => (item.id))
                                            },
                                            fieldUpdates: [
                                                {
                                                    name: 'accounts',
                                                    updates: [
                                                        {
                                                            key: 'options',
                                                            value: this.state.extraData.accounts
                                                        },
                                                    ]
                                                }
                                            ],
                                        }
                                    },
                                    {
                                        title: 'Свободный текст',
                                        value: this.state.letter.free_text,
                                        html: true,
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        edit: {
                                            permission: true,
                                            fields: ['free_text',],
                                            baseUrl: 'letter',
                                            obj: this.state.letter,
                                        }
                                    },
                                ]
                            },
                            {
                                title: 'Персоналии',
                                icon: <ContactPageIcon />,
                                fields: [
                                    (() => {
                                        if (this.state.letter.lead){
                                            return null
                                        }
                                        return(
                                            {
                                                title: 'Получатель',
                                                value: `${this.state.letter.contact?.first_name} ${this.state.letter.contact?.last_name} - ${this.state.letter.contact?.role}`,
                                                xs: 12,
                                                sm: 12,
                                                md: 6,
                                                lg: 6,
                                                edit: {
                                                    permission: true,
                                                    fields: ['contact',],
                                                    baseUrl: 'letter',
                                                    obj: {
                                                        id: this.state.letter.id,
                                                        contact: this.state.letter.contact?.id
                                                    },
                                                    fieldUpdates: [
                                                        {
                                                            name: 'contact',
                                                            updates: [
                                                                {
                                                                    key: 'options',
                                                                    value: this.state.extraData.contacts
                                                                },
                                                            ]
                                                        }
                                                    ],
                                                }
                                            }
                                        )
                                    })()
                                    ,
                                    {
                                        title: 'Подписант',
                                        value: `${this.state.letter.signature?.user.first_name} ${this.state.letter.signature?.user.last_name}`,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        edit: {
                                            permission: true,
                                            fields: ['signature',],
                                            baseUrl: 'letter',
                                            obj: {
                                                id: this.state.letter.id,
                                                signature: this.state.letter.signature?.id
                                            },
                                            fieldUpdates: [
                                                {
                                                    name: 'signature',
                                                    updates: [
                                                        {
                                                            key: 'options',
                                                            value: this.state.extraData.signature
                                                        },
                                                    ]
                                                }
                                            ],
                                        }
                                    },
                                ]
                            }
                        ]
                    }
                />
            </Stack>
        )
    }
}

export default LetterDetailInner
